import { useContext } from "react";
import { ArtisContext } from "./provider.js";
/**
 * Read the {@link Artis} instance from the nearest `<ArtisAppProvider>`. Returns `null`
 * while the worker handshake is in flight. You rarely need this directly: the watcher
 * hooks ({@link useWatcherRefs}, {@link useWatcherUpdates}) and {@link useOnSelection}
 * cover the common paths.
 *
 * @throws if called outside an `<ArtisAppProvider>`.
 */
export const useArtis = () => {
    const value = useContext(ArtisContext);
    if (value === undefined)
        throw new Error("useArtis must be used inside an ArtisProvider");
    return value;
};
//# sourceMappingURL=useArtis.js.map